import * as React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { useTranslate, useLocaleState, Title } from "react-admin";
// import { useTheme } from "react-admin";
// import { darkTheme, lightTheme } from "../layout/themes";
import { useSystemName } from "../components/InputFields";

const Configuration = () => {
  const translate = useTranslate();
  const [locale, setLocale] = useLocaleState();
  // const [theme, setTheme] = useTheme();
  const systemName = useSystemName();
  // console.log(`{Configuration} systemName: ${systemName}, theme:`, theme);
  // console.log(`{Configuration} theme.palette.mode:`, theme?.palette?.mode);
  // console.log(`{Configuration} theme.name:`, theme?.name);

  return (
    <Card sx={{ marginTop: "10px" }}>
      {/*<Title title={translate('pos.configuration')} />*/}
      <Title title={`Configuration ${systemName}`} />
      {/* Theme Section - Commented Out */}
      {/*<CardContent>
        <Box sx={{ width: "10em", display: "inline-block" }}>
          {translate("pos.theme.name")}
        </Box>
        <Button
          variant="contained"
          sx={{
            margin: "1em",
            ...(theme?.palette?.mode !== "light" && {
              backgroundColor: "#505050",
              "&:hover": { backgroundColor: "#404040" },
            }),
          }}
          color={theme?.palette?.mode === "light" ? "primary" : undefined}
          onClick={() => setTheme(lightTheme)}
        >
          {translate("pos.theme.light")}
        </Button>
        <Button
          variant="contained"
          sx={{
            margin: "1em",
            ...(theme?.palette?.mode !== "dark" && {
              backgroundColor: "#505050",
              "&:hover": { backgroundColor: "#404040" },
            }),
          }}
          color={theme?.palette?.mode === "dark" ? "primary" : undefined}
          onClick={() => setTheme(darkTheme)}
        >
          {translate("pos.theme.dark")}
        </Button>

        <Button
          variant="contained"
          sx={{margin: '1em'}}
          color={
            theme.name === 'plain'
              ? 'primary'
              : 'secondary'
          }
          onClick={() => setTheme(plainTheme)}
        >
          {translate('pos.theme.plain')}
        </Button>
      </CardContent>*/}
      <CardContent>
        <Box sx={{ width: "10em", display: "inline-block" }}>
          {translate("pos.language")}
        </Box>
        <Button
          variant="contained"
          sx={{ margin: "1em" }}
          color={locale === "en" ? "primary" : "secondary"}
          onClick={() => setLocale("en")}
        >
          en
        </Button>
        <Button
          variant="contained"
          sx={{ margin: "1em" }}
          color={locale === "fr" ? "primary" : "secondary"}
          onClick={() => setLocale("fr")}
        >
          fr
        </Button>
      </CardContent>
    </Card>
  );
};

export default Configuration;
